<template>
  <div>
    <div class="comm_popup_wrap_large">
      <div class="comm_title_wrap">
        <h4>{{ $t("MSG_TXT_TASK_MNRT_RQS_INFO") }}</h4>
      </div>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_TYPE_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringRequestData.taskMonitoringTypeName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringRequestData.moduleName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="taskMonitoringRequestData.subModuleName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXPL')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <textarea
              v-model.trim="taskMonitoringRequestData.taskMonitoringTypeContent"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TASK_MNTR_PRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringRequestData.taskMonitoringCycleTypeName"
              placeholder
              :disabled="false"
              :readonly="true"
            />

            <div
              v-show="taskMonitoringRequestData.taskMonitoringCycleTypeCode == 'W'"
              class="comp_spacing"
            />
            <sui-text-field
              v-show="taskMonitoringRequestData.taskMonitoringCycleTypeCode == 'W'"
              v-model.trim="taskMonitoringRequestData.taskMonitoringStandardDayOfTheWeekName"
              placeholder
              :disabled="false"
              :readonly="true"
            />

            <div
              v-show="taskMonitoringRequestData.taskMonitoringCycleTypeCode == 'M'"
              class="comp_spacing"
            />
            <sui-text-field
              v-show="taskMonitoringRequestData.taskMonitoringCycleTypeCode == 'M'"
              v-model.trim="taskMonitoringRequestData.taskMonitoringStandardDay"
              placeholder
              :disabled="false"
              :readonly="true"
            />

            <div class="comp_spacing" />
            <sui-time-picker
              v-model.trim="timePickerValue"
              format="HH:mm"
              :disabled="true"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RSULT_SEND_MD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringRequestData.taskMonitoringSendMediaName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_START_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringRequestData.taskMonitoringStartDate"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div
            v-show="convertExtractionStandardValue.startDate != null"
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_STNDR_START_DT')"
              :vertical="false"
            />
          </div>
          <div
            v-show="convertExtractionStandardValue.startDate != null"
            class="col-xs-5"
          >
            <sui-text-field
              v-model.trim="convertExtractionStandardValue.startDate"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
          <div
            v-show="convertExtractionStandardValue.endDate != null"
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_STNDR_END_DT')"
              :vertical="false"
            />
          </div>
          <div
            v-show="convertExtractionStandardValue.endDate != null"
            class="col-xs-5"
          >
            <sui-text-field
              v-model.trim="convertExtractionStandardValue.endDate"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div
          v-show="convertExtractionStandardValue.siteId != null"
          class="row"
        >
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_STNDR_SITE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="convertExtractionStandardValue.siteId"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div
          v-for="item in extractionStandardValues"
          :key="item.key"
          class="row"
        >
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXTC_STNRD')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ item.label }}
            </div>
            <div class="comp_spacing" />
            <sui-text-field
              v-model.trim="item.key"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RQS_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="taskMonitoringRequestData.taskMonitoringRequestStateName"
              placeholder
              :disabled="false"
              :readonly="true"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TMPS')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <sui-radio
              v-model="taskMonitoringRequestData.taskMonitoringRequsetTemporaryPauseYn"
              value="Y"
            >
              Yes
            </sui-radio>
            <sui-radio
              v-model="taskMonitoringRequestData.taskMonitoringRequsetTemporaryPauseYn"
              value="N"
            >
              No
            </sui-radio>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RSULT_FILE')"
              :vertical="false"
            />
          </div>
          <div
            class="col-xs-11"
            style="display:block;"
          >
            <div style="display:flex;">
              <sui-range-date-picker
                ref="datePicker"
                v-model="rangeDate"
                :value="rangeDate"
              />
              <div class="comp_spacing" />
              <sui-button
                type="button"
                name="button"
                class="btn_innerTbl_border"
                @click="onSearchTaskMonitoringHistoryList"
              >
                {{ $t("MSG_BTN_SEARCH") }}
              </sui-button>
            </div>
            <div class="mrB10" />
            <sui-grid
              ref="grid"
              :hideheader="false"
              :showCountControl="true"
              :showDisplayCountControl="false"
              :columns="gridColumns0"
              :dataset="'dsTaskMonitoringHistory'"
              :rowMovable="false"
              :multiselect="false"
              :pageable="false"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onClose"
      >
        {{ $t("MSG_BTN_CANCEL") }}
      </sui-button>
      <sui-button
        v-permission:update="pageId"
        type="button"
        class="comm_btn_solid"
        @click="onSave"
      >
        {{ $t("MSG_BTN_SAVE") }}
      </sui-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PGE_CMS_00015_P02', // eslint-disable-line vue/name-property-casing
  props: {
    pageId: {
      type: String,
      default: 'PGE_CMS_00015',
    },
    taskMonitoringRequestUID: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      extractionStandardValues: [],

      convertExtractionStandardValue: {
        startDate: null,
        endDate: null,
        siteId: '',
        siteName: '',
      },

      timePickerValue: {
        HH: '00',
        mm: '00',
      },

      taskMonitoringRequestData: {
        taskMonitoringRequestUID: '',
        taskMonitoringTypeUID: '',
        taskMonitoringStartDate: '',
        taskMonitoringRequestStandardValue: '',
        taskMonitoringRequsetTemporaryPauseYn: 'N',
        taskMonitoringRequestStateCode: '',
        taskMonitoringRequestStateName: '',
        taskMonitoringCycleTypeCode: '',
        taskMonitoringCycleTypeName: '',

        moduleCode: '',
        moduleName: '',
        subModuleCode: '',
        subModuleName: '',
        taskMonitoringTypeName: '',
        taskMonitoringTypeContent: '',
        taskMonitoringStandardDayOfTheWeekCode: '',
        taskMonitoringStandardDayOfTheWeekName: '',
        taskMonitoringStandardDay: '',
        taskMonitoringStandardTime: '',
        taskMonitoringSendMediaCode: '',
        taskMonitoringSendMediaName: '',

        firstRegistrationUserId: '',
        firstRegistrationDTM: '',
        finalModificationUserId: '',
        finalModificationDTM: '',
        originalFinalModificationDTM: '',
      },

      rangeDate: {
        from: '',
        to: '',
      },

      localdata0: [],

      gridColumns0: [{
        text: this.$t('MSG_TXT_DT'),
        datafield: 'firstRegistrationDTM',
        width: 90,
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, { formatOption: 'S' }, this.dsTaskMonitoringHistory, this.$refs.grid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),        
      }, {
        text: this.$t('MSG_TXT_HIS_STT'),
        datafield: 'taskMonitoringHistoryStateName',
        width: 100,
      }, {
        text: this.$t('MSG_TXT_MNRT_RSULT'),
        datafield: 'taskMonitoringResultFilePath',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
            handler: this.onDownloadButtonClicked,
          }, this.dsTaskMonitoringHistory, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsTaskMonitoringHistory',
    type: 'local',
    data: 'localdata0',
    datafields: [
      {
        name: 'firstRegistrationDTM',
        type: 'string',
        map: 'firstRegistrationDTM',
      }, {
        name: 'taskMonitoringHistoryStateCode',
        type: 'string',
        map: 'taskMonitoringHistoryStateCode',
      }, {
        name: 'taskMonitoringHistoryStateName',
        type: 'string',
        map: 'taskMonitoringHistoryStateName',
      }, {
        name: 'taskMonitoringResultFilePath',
        type: 'string',
        map: 'taskMonitoringResultFilePath',
      },
    ],
  }],
  mounted() {
    this.searchTaskMonitoringRequest(this.taskMonitoringRequestUID);
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
      ***************************************************************************** */
    onClose() {
      this.$emit('close');
    },
    onSave() {
      this.save(this.taskMonitoringRequestUID);
    },
    onDownloadButtonClicked(btn, dataRow) {
      const fileName = dataRow.taskMonitoringResultFilePath[0].key;
      const queryParams = {
        originalFileName: fileName,
        serverFileName: fileName,
      };
      http.request(this.pageId, 'DTS_CMZ_00068', {
        path: { 'target-path': 'export' },
        query: queryParams,
        responseType: 'arraybuffer',
      }).then(res => {
        utils.downloadBlob(res, fileName);
      });
    },
    onSearchTaskMonitoringHistoryList() {
      // date picker validation
      if (this.onClickValidate()) return false;
      this.searchTaskMonitoringHistoryList(this.taskMonitoringRequestUID);

      return null;
    },
    /** ***************************************************************************
        함수 영역
      ***************************************************************************** */
    searchTaskMonitoringRequest(sTaskMonitoringRequestUID) {
      http.request(this.pageId, 'DTS_CMS_00038', {
        path: {
          'task-monitoring-request-id': utils.trim(sTaskMonitoringRequestUID),
        },
      }).then(res => {
        const has = Object.prototype.hasOwnProperty;
        utils.forEach(res.data, (value, key) => {
          if (utils.has(this.taskMonitoringRequestData, key)) {
            if (has.call(this.taskMonitoringRequestData[key], 'key')) {
              utils.set(this.taskMonitoringRequestData, key, { key: value, label: '' });
            } else {
              utils.set(this.taskMonitoringRequestData, key, value);
            }
          }
          this.setExtractionStandardValues();
        });

        const sStandarDate = `${this.taskMonitoringRequestData.taskMonitoringStandardTime}`;
        this.timePickerValue = { HH: sStandarDate.substr(0, 2), mm: sStandarDate.substr(2, 2) };

        this.taskMonitoringRequestData.originalFinalModificationDTM = this.taskMonitoringRequestData
          .finalModificationDTM;

        // date format
        this.taskMonitoringRequestData.taskMonitoringStartDate = moment(this.taskMonitoringRequestData.taskMonitoringStartDate).format('YYYY-MM-DD');
        this.convertExtractionStandardValue.startDate = moment(this.convertExtractionStandardValue.startDate).format('YYYY-MM-DD');
        this.convertExtractionStandardValue.endDate = moment(this.convertExtractionStandardValue.endDate).format('YYYY-MM-DD');

        // 이력 목록 조회
        this.searchTaskMonitoringHistoryList(sTaskMonitoringRequestUID);
      }).catch(error => {
        console.log(error);
      });
    },
    // extractionStandardValues, convertExtractionStandardValue
    setExtractionStandardValues() {
      const sStandardValues = utils.clone(this.taskMonitoringRequestData.taskMonitoringRequestStandardValue);

      this.extractionStandardValues = [];
      // AAA=111,BBB=222,CCC=333
      if (utils.isEmpty(sStandardValues) === false) {
        const tempArray = sStandardValues.split(',');
        utils.forEach(tempArray, standardValue => {
          const tempStandValue = standardValue.split('=');
          if (utils.has(this.convertExtractionStandardValue, tempStandValue[0])) {
            this.convertExtractionStandardValue[tempStandValue[0]] = tempStandValue[1]; //eslint-disable-line
          } else {
            this.extractionStandardValues.push({
              key: tempStandValue[0],
              label: tempStandValue[1],
            });
          }
        });
      }
    },
    save(sTaskMonitoringRequestUID) {
      // searchBox -> paramsObj변환 { key : value, key : value }
      const dataParams = utils.reduce(this.taskMonitoringRequestData, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      // save
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.pageId, 'DTS_CMS_00040', {
          path: {
            'task-monitoring-request-id': utils.trim(sTaskMonitoringRequestUID),
          },
          data: dataParams,
        }).then(res => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'));
          this.$emit('save');
          console.log(res);
        }).catch(error => {
          console.log(error);
        });
      });
    },
    searchTaskMonitoringHistoryList(sTaskMonitoringRequestUID) {
      let sStartDate = '';
      let sEndDate = '';
      if (this.rangeDate.from !== null && this.rangeDate.from !== '') {
        sStartDate = utils.dateformatToServer(this.rangeDate.from);
      }
      if (this.rangeDate.to !== null && this.rangeDate.to !== '') {
        sEndDate = utils.dateformatToServer(this.rangeDate.to);
      }

      http.request(this.pageId, 'DTS_CMS_00044', {
        path: {
          'task-monitoring-request-id': utils.trim(sTaskMonitoringRequestUID),
        },
        query: {
          taskMonitoringParamStartDTM: sStartDate,
          taskMonitoringParamEndDTM: sEndDate,
        },
      }).then(res => {
        utils.forEach(res.data, item => {
          const items = item;
          items.taskMonitoringResultFilePath = [
            {
              key: item.taskMonitoringResultFilePath,
              label: item.taskMonitoringResultFilePath,
              type: 'sublink',
            },
          ];
        });

        this.dsTaskMonitoringHistory.setRawData(res.data);
        // console.log(res);
      }).catch(error => {
        console.log(error);
      });
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // date picker validation
      // if (this.onClickValidate()) return false;
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },

  },
};
</script>
<style scoped>
</style>
